import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import { TutorialTooltipReducer, VerificationModal } from '@adc/ui-adc'
import user from './user'
import properties from './properties'
import listing from './listing'
import modals from './modals'
import propertyAnalytics from './propertyAnalytics'
import featureFlags from './featureFlags'
import directOffer from './directOffer'
import suggestedOffer from './suggestedOffer'
import venue from './venue'
import app from './app'

const { reducer: verificationModalReducer } = VerificationModal

export default combineReducers({
  verificationModalReducer,
  user,
  properties,
  listing,
  modals,
  form: formReducer,
  tutorial: TutorialTooltipReducer,
  venue,
  featureFlags,
  propertyAnalytics,
  directOffer,
  suggestedOffer,
  app,
})
